import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as sharedActions from "../actions/shared.actions";
import { IClient } from "../models/client.model";

export type Actions = sharedActions.All;

export interface ISharedFeatureModuleState {
  sharedState: IState;
}

export interface IState {
  "client": IClient;
  "ip": string;
}

const initialState: IState = {
  client: null,
  ip: "NA",
};

export function reducer(state: IState = initialState, action: Actions) {
  switch (action.type) {
    case sharedActions.LOAD_CLIENT_SUBMIT:
      return { ...state, client: action.payload };
    case sharedActions.LOAD_CLIENT_FAILED:
      return initialState;
    case sharedActions.LOAD_IP_SUBMIT:
      return { ...state, ip: action.payload };
    default:
      return state;
  }
}

export const getSharedFeatureModule = createFeatureSelector<ISharedFeatureModuleState>("sharedFeatureModule");
export const getSharedState = createSelector(
  getSharedFeatureModule,
  (state: ISharedFeatureModuleState) => state.sharedState,
);
export const getClient = createSelector(getSharedState, (state: IState) => state.client);
export const getClientId = createSelector(getClient, (state: IClient) => state ? state.id : null);
export const getClientMinimalData = createSelector(getClient, (state: IClient) =>
  state ? { id: state.id, defaultLanguage: state.defaultLanguage } : null);
export const getClientDefaultLanguage = createSelector(
  getClient,
  (state: IClient) => state ? state.defaultLanguage : null,
);
export const getIp = createSelector(getSharedState, (state: IState) => state.ip);



// WEBPACK FOOTER //
// ./src/shared/reducers/shared.reducer.ts